module.exports = __webpack_public_path__ + "static/img/gift-box-close.7e825327.png";